import { Backdrop, Box, Typography } from "@mui/material";
import React from "react";
interface BackdropProgressBarProps {
  loading: boolean;
  showAbsolute?: boolean;
}

const BackdropProgressBar: React.FC<BackdropProgressBarProps> = ({ loading, showAbsolute = false }) => {
  return (
    <Backdrop
      sx={(theme) => ({
        zIndex: theme.zIndex.modal + 100,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        ...(showAbsolute && { position: "absolute" }),
      })}
      open={loading}
      className="custom-backdrop"
    >
      <Box
        component="img"
        src="/loading-logo.gif"
        alt=""
        aria-hidden
        sx={{ width: 72, height: 72, objectFit: "contain" }}
      />

      <Typography variant="h6" sx={{ fontSize: 14, fontWeight: 600 }}>
        Loading...
      </Typography>
    </Backdrop>
  );
};

export default BackdropProgressBar;
